import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadFileDialog } from 'shell/components';
import { CONTENT_BANK_ALLOWED_FILE_TYPES, CONTENT_BANK_RESOURCES_MB_LIMIT } from 'utils/constants';
import { bytesToMB } from 'utils/helper';

const UploadContentBankResourcesDialog = memo(({ open, resources, onClose, onClick }) => {
    const { t } = useTranslation('assignment');

    const [error, setError] = useState('');

    const handleClickUpload = (files) => {
        const sizeAlreadyUploaded = bytesToMB(
            [
                ...files.map(({ data }) => data.size),
                ...resources?.filter(({ active }) => active)?.map(({ data }) => data.size),
            ].reduce((acc, cur) => acc + cur, 0)
        );
        if (sizeAlreadyUploaded > CONTENT_BANK_RESOURCES_MB_LIMIT) {
            setError(t('common:errors.upload-exceeds-limit', 'Uploads exceed the file upload limit.'));
            return;
        }
        onClick(
            files.map((file) => ({
                ...file,
                description: '',
                resource_type: '',
            }))
        );
        onClose();
    };

    return (
        <UploadFileDialog
            allowedFileTypes={CONTENT_BANK_ALLOWED_FILE_TYPES}
            description={t(
                'upload-files.description-500',
                'Please upload only essential materials for this assignment (max 200MB) to avoid errors. Please make sure each file is no larger than 500MB.'
            )}
            error={error}
            open={open}
            title={t('upload-files.title', 'Upload Files')}
            onClickUpload={handleClickUpload}
            onClose={onClose}
        />
    );
});

export default UploadContentBankResourcesDialog;
